$(document).ready(function () {

  if ($('.CutSafelyPage').length > 0) {

    $(document).on('click', '.switch-list-button', function () {

      $('.split-column').slideUp();

      if (!$(this).hasClass('open')) {
        $(this).siblings('.split-column').slideDown();
        $('.switch-list-button').removeClass('open');
        $(this).addClass('open');
      } else {
        $(this).removeClass('open');
      }
    });

    //smoothscroll
    $('.jump-button').on('click', function (e) {
      e.preventDefault();

      $elementByURLId = $(this.hash);

      $('html, body').stop().animate({
        'scrollTop': $elementByURLId.offset().top
      }, 500, 'swing');
    });


    $(document).on('click', '.region-toggle', function () {

      $('.company').slideUp();

      if (!$(this).hasClass('open')) {
        $(this).siblings('.company').slideDown();
        $('.region-toggle').removeClass('open');
        $(this).addClass('open');
      } else {
        $(this).removeClass('open');
      }
    });
  }
});
